import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LeftDrawer from '../components/LeftDrawer';
import { AppBar, Toolbar, Typography, Box, Drawer, List, ListItem, ListItemText, Container, Button  } from '@mui/material';
import { useLocation, useNavigate  } from 'react-router-dom'; 
import { useAuth } from '../context/AuthContext';
import ConfirmationDialog from '../components/ConfirmationDialog';
import CommentPopup from '../components/CommentPopup';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const QuoteListPage = () => {
  const [quotes, setQuotes] = useState([]);
 const navigate = useNavigate(); 
       const { user } = useAuth();
    
 const { email, name, userId, roles, userTypes} =  user || {};
    
     const fetchQuote = async () => {
    if (email) {
      // Fetch the quotes from API based on the user's email
        
        let quoteURL = `${backendUrl}/api/users/${userId}/quote/getAll`  
        if(Array.isArray(roles) && roles.some(userRole => userRole.role === 'ROLE_ADMIN')){
            
            console.log("admin quote url ")
           quoteURL = `${backendUrl}/api/quote-request`
           }
        
      axios.get(quoteURL)
        .then((response) => {
          setQuotes(response.data);
        })
        .catch((error) => {
          console.error('Error fetching quotes:', error);
        });
    }
      }
    
  useEffect(() => {
     
      fetchQuote();
      
  }, [email]);

  // Define columns for the data grid
  const columns  =  [
  { field: 'quoteUniqueId', headerName: 'Quote ID', width: 200 },
  { field: 'name', headerName: 'Author', width: 150 },
      { field: 'message', headerName: 'Quote', width: 150 },
  { field: 'status', headerName: 'Status', width: 100 },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 250,
    renderCell: (params) => {
     
     if((Array.isArray(roles) && roles.some(userRole => userRole.role === 'ROLE_ADMIN'))){
        return (
          <>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => handleApprove(params.row.quoteUniqueId,'quote')}
              style={{ marginRight: 8 }}
            >
              Update Quote
            </Button>
       </>
      );
  } else if(params.row.status !== 'Approved'){
     
     return (
          <>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => handleApprove(params.row.quoteUniqueId,'quote')}
              style={{ marginRight: 8 }}
            >
              Update Quote
            </Button>
       </>
      );
     } else {
     
      return null;
     }
     
     
     
     }
      
    }, {
    field: 'view',
    headerName: 'View Comment',
    width: 150,
    renderCell: (params) => (
      <Button
        variant="text"
        color="primary"
        onClick={() => handleViewComments(params.row.quoteUniqueId,'quote')}
      >
        View Details
      </Button>
    ),
  }
, {
    field: 'fileLink',
    headerName: 'Download ',
    width: 150,
    renderCell: (params) => (
      
      <Button
        variant="text"
        color="primary"
        onClick={() => handleViewQuote(params.row.fileLink, params.row.fileName)}
      >
        Download/View
      </Button>
    ),
  }
  
];

 const [selectedId, setSelectedId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
      const [type, setType] = useState(null);
 const [openPopup, setOpenPopup] = useState(false);

  const handleViewComments = (id, type) => {
    setSelectedId(id);
    setOpenPopup(true);
       setType(type);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
       setType(null);
  };

  const handleApprove = (id, type) => {
    setSelectedId(id);
    setOpenDialog(true); // Open the confirmation dialog
      setType(type);
  };

    
  const handleConfirm = async (status, comment,attachment) => {
      
      let updatStatusURL = `${backendUrl}/api/quote-request/${selectedId}/update`

      
      const commentDTO = {
  userId: userId,
  statusId: status,
  comment: comment,
  // other fields if needed
};

const formData = new FormData();
formData.append("commentDTO", new Blob([JSON.stringify(commentDTO)], { type: "application/json" }));
formData.append("attachment", attachment);
      
      
      await axios.post(updatStatusURL, formData)
      .then((response) => {
        console.log('Quote approved:', response.data);
        // Optionally refresh the grid or update the status locally
      })
      .catch((error) => {
        console.error('Error approving quote:', error);
      });
  
     await fetchQuote();
      
      console.log("update quote  " + userId + "status "+ status);
    setType(null);
    setOpenDialog(false); // Close the dialog after confirming
  };



const handleDecline = (id) => {
  console.log('Declined row with id:', id);
  // Add your logic to handle the decline action (e.g., update the status, make API calls, etc.)
};


const handleViewQuote = (fileLink,fileName) => {
  
    if(fileLink === null || fileLink === undefined || fileLink === "" ){
        
        alert("There is no attachment");
        return;
    }
    
     axios({
      url: `${backendUrl}/api/quote-request/download?filePath=${fileLink}`, // Replace with your backend URL
      method: 'GET',
      responseType: 'blob', // Important to specify blob response
    })
    .then((response) => {
      // Create a URL from the response blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Suggest the filename
      link.setAttribute('download', fileName); // Replace with your desired file name
      document.body.appendChild(link);
      
      // Start download
      link.click();
      
      // Clean up
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error('There was an error downloading the file!', error);
    });
    
}


  // Navigation handlers for the menu items
  const handleRequestQuote = () => navigate('/request-quote');
  const handleQuoteList = () => navigate('/quote-list');
  const handleOrders = () => navigate('/orders');
     const handleTracker = () => navigate('/tracker');
    
      const handleDealer = () => navigate('/dealerreg');
      const handleDealers = () => navigate('/dealers');
     
  const handleSupplier = () => navigate('/suppliereg');
      const handleSuppliers = () => navigate('/suppliers');
     const handleManufacturer = () => navigate('/manufacturerreg');
    
     const handleManufacturers = () => navigate('/manufacturers');
    
      const handleDashboard = () => navigate('/dashboard');
    
   const handleProfile = () => navigate('/profile');
    const handlePurchaseOrder = () => navigate('/purchaseorder')
    const handleSendEstimate = () => navigate('/send-estimate')
    const handleEstimate = () => navigate('/estimate')
   const handlePartner = () => navigate('/partner')
      const handleInvoice = () => navigate('/invoice')
      const handleTrader = () => navigate('/trader')
        const handleBuilder = () => navigate('/builder')
       const handlePartnerView = () => navigate('/partnerview')
      const handlePurchaseOrderList = () => navigate('/purchaseorderlist')
      const handleInvoiceView = () => navigate('/invoiceview')
         const handleReport = () => navigate('/report');
       const handleParts = () => navigate('/parts');
           const handlePartGroup = () => navigate('/partgroup');
         const handleBuilders = () => navigate('/builders');
         const handleTraders = () => navigate('/traders');
        const handleGRN = () => navigate('/grn');
    
    
    
  return (

    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header at the Top */}
       <AppBar position="static" sx={{ backgroundColor: '#941B0C' }}>
      <Toolbar>
        {/* Left-aligned Dashboard Title */}
        <Typography variant="h6" noWrap component="div">
          Dashboard
        </Typography>

        {/* Spacer to push the name to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Right-aligned Name */}
        <Typography variant="h6" noWrap component="div">
          Welcome {name}
        </Typography>
      </Toolbar>
    </AppBar>

     <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <LeftDrawer
        handleDashboard={handleDashboard}
      handleProfile={handleProfile}
          handleRequestQuote={handleRequestQuote}
          handleQuoteList={handleQuoteList}
          handleOrders={handleOrders}
          handleTracker={handleTracker}
          handleDealer={handleDealer}
          handleDealers={handleDealers}
          handleSupplier={handleSupplier}
       handleSuppliers={handleSuppliers}
          handleManufacturer={handleManufacturer}
      handleManufacturers={handleManufacturers}
        handlePurchaseOrder={handlePurchaseOrder}
      handleSendEstimate={handleSendEstimate}
      handleEstimate={handleEstimate}
       handlePartner={handlePartner}
      handleInvoice={handleInvoice}
      handleTrader={handleTrader}
      handleBuilder={handleBuilder}
      handlePartnerView={handlePartnerView}
      handlePurchaseOrderList={handlePurchaseOrderList}
      handleInvoiceView={handleInvoiceView}
      handleReport={handleReport}
      handleParts={handleParts}
      handlePartGroup={handlePartGroup}
      handleTraders={handleTraders}
      handleBuilders={handleBuilders}
            handleGRN={handleGRN}
          userRoles={roles}
          userTypes={userTypes}
/>
      
    <div style={{ height: 400, width: '100%' }}>
      <h2>Quote List</h2>
      <DataGrid rows={quotes} columns={columns} pageSize={5}   getRowId={(row) => row.quoteUniqueId} 
  />
 {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        handleConfirm={handleConfirm}
        type={type}
      />
            
             {openPopup && (
        <CommentPopup
          open={openPopup}
          handleClose={handleClosePopup}
          rowId={selectedId}
         type={type}
        />
      )}
    </div>
      </Box>
      </Box>
      
  );
};

export default QuoteListPage;
